module.exports = __webpack_public_path__ + "assets/img/desc-02-6334ebaa.png";